import { useTheme } from "@hooks/useTheme";
import { formatUserNameWithId, getUserDisplayParts } from "@utils/userDisplay";

/**
 * User display for CSC-195.
 * - layout="stacked" (default): two lines for table list cells — name, then italic id
 * - layout="inline": one line for detail views — name + italic (id), truncates with ellipsis
 */
export default function UserNameWithId({
  name,
  id,
  layout = "stacked",
  className = "",
  "data-testid": dataTestId,
}) {
  const { colors } = useTheme();
  const { name: displayName, id: displayId } = getUserDisplayParts(name, id);
  const title = formatUserNameWithId(name, id);

  if (!displayName && !displayId) {
    return (
      <span className={`block w-full min-w-0 truncate text-sm ${colors.textPrimary} ${className}`} title={title} data-testid={dataTestId}>
        ---
      </span>
    );
  }

  if (layout === "inline") {
    return (
      <span
        className={`block w-0 min-w-full max-w-full truncate text-sm ${colors.textPrimary} ${className}`}
        title={title}
        data-testid={dataTestId}
      >
        {displayName ? <span>{displayName}</span> : null}
        {displayId ? (
          <span className={`italic ${colors.textSubTitle}`}>
            {displayName ? " " : ""}
            ({displayId})
          </span>
        ) : null}
      </span>
    );
  }

  return (
    <div className={`min-w-0 w-full leading-tight ${className}`} title={title} data-testid={dataTestId}>
      <div className={`truncate text-sm ${colors.textPrimary}`}>{displayName || "---"}</div>
      {displayId ? <div className={`truncate text-xs ${colors.textSubTitle}`}>{displayId}</div> : null}
    </div>
  );
}
